import Enum from '@/modules/core/app/helpers/Enum';
import { Icon } from '@/modules/core/app/enums/Icon';

export class ToastType extends Enum {
  key!: string;
  icon!: Icon;

  static SUCCESS: ToastType = {
    key: 'is-success',
    icon: Icon.CHECK_CIRCLE_1
  };

  static ERROR: ToastType = {
    key: 'is-danger',
    icon: Icon.REMOVE_CIRCLE
  };

  static WARNING: ToastType = {
    key: 'is-warning',
    icon: Icon.ALERT_CIRCLE
  };

  static DEFAULT: ToastType = {
    key: 'is-primary',
    icon: Icon.INFORMATION_CIRCLE
  };
}
